// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-file-wrap[data-v-607c4adb] {\n  display: flex;\n  color: #3552ba;\n}", ""]);
// Exports
module.exports = exports;
